/* ==========================================================
   BILIPING SPEED & UX SYSTEM (META ADS OPTIMIZED)
   - LCP Image Boost
   - Smart Instant Navigation (Hover intent, no touch spam)
   - Targeted Cart Failsafe (No global DOM observers)
========================================================== */
(() => {
  'use strict';

  const prefetched = new Set();
  const canPrefetch = (() => {
    const link = document.createElement('link');
    return !!(link.relList && link.relList.supports && link.relList.supports('prefetch'));
  })();

  function normalizeUrl(url) {
    try {
      const u = new URL(url, location.origin);
      if (u.origin !== location.origin) return null;
      if (u.protocol !== 'http:' && u.protocol !== 'https:') return null;
      if (u.hash && u.pathname === location.pathname && u.search === location.search) return null;
      if (/\/(cart|checkout)(\/|$)/.test(u.pathname)) return null;
      return u.href;
    } catch {
      return null;
    }
  }

  function prefetchUrl(url) {
    const href = normalizeUrl(url);
    if (!href || prefetched.has(href) || !canPrefetch) return;
    prefetched.add(href);
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.as = 'document';
    link.href = href;
    document.head.appendChild(link);
  }

  function wireInstantNav() {
    if (navigator.connection && navigator.connection.saveData) return;
    
    let hoverTimer;

    const prefetchIntent = (event) => {
      const anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
      if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download') || (anchor.rel || '').includes('external')) return;
      
      const href = anchor.href;
      
      // OPTIMIZACIJA: Ako je u pitanju "pointerenter" (miš), čekamo 65ms da vidimo da li je korisnik samo slučajno prešao preko linka.
      if (event.type === 'pointerenter') {
        hoverTimer = setTimeout(() => prefetchUrl(href), 65);
      } else {
        // pointerdown / focusin reaguju trenutno
        prefetchUrl(href);
      }
    };

    const clearIntent = () => {
      clearTimeout(hoverTimer);
    };

    document.addEventListener('pointerenter', prefetchIntent, true);
    document.addEventListener('pointerleave', clearIntent, true);
    document.addEventListener('pointerdown', prefetchIntent, true);
    document.addEventListener('focusin', prefetchIntent, true);
    // Uklonjen 'touchstart' jer izaziva masovno lažno okidanje i zagušenje mreže tokom skrolanja na mobilnim!
  }

  function boostLcpImage() {
    const candidates = [
      'main .product__media img',
      'main product-info img',
      '#MainContent img[loading="eager"]',
      '#MainContent .banner__media img',
      '#MainContent .image-banner img',
      '#MainContent img'
    ];

    let img = null;
    for (const selector of candidates) {
      img = document.querySelector(selector);
      if (img) break;
    }
    if (!img) return;

    img.setAttribute('fetchpriority', 'high');
    img.setAttribute('decoding', 'async');
    if (!img.complete && !img.hasAttribute('loading')) {
      img.setAttribute('loading', 'eager');
    }
    if (typeof img.decode === 'function') {
      img.decode().catch(() => {});
    }
  }

  function cleanCartUi(root = document) {
    root.querySelectorAll('.cart__items--disabled').forEach((el) => {
      el.classList.remove('cart__items--disabled');
    });
    root.querySelectorAll('.cart .loading__spinner, cart-items .loading__spinner, cart-drawer-items .loading__spinner').forEach((el) => {
      el.classList.add('hidden');
    });
  }

  function wireCartFailsafe() {
    const cartRoots = document.querySelectorAll('cart-items, cart-drawer-items, .cart, cart-drawer');
    if (!cartRoots.length) return; // Ako nema korpe na stranici, završavamo.

    let cleanupTimer = 0;
    const scheduleCleanup = () => {
      window.clearTimeout(cleanupTimer);
      cleanupTimer = window.setTimeout(() => {
        cartRoots.forEach(root => cleanCartUi(root));
      }, 80);
    };

    // Prvo čišćenje prilikom učitavanja
    cartRoots.forEach(root => cleanCartUi(root));
    window.setTimeout(() => cartRoots.forEach(root => cleanCartUi(root)), 1000);
    window.setTimeout(() => cartRoots.forEach(root => cleanCartUi(root)), 2500);

    // OPTIMIZACIJA: Postavljamo MutationObserver ISKLJUČIVO na korpu, a ne na cijeli body! 
    // Ovo spašava mobilni procesor.
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && (mutation.addedNodes.length || mutation.removedNodes.length)) {
          scheduleCleanup();
          break;
        }
      }
    });

    cartRoots.forEach(root => {
      observer.observe(root, { childList: true, subtree: true });
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target && event.target.closest ? event.target.closest('button, a, input, select') : null;
      if (!trigger) return;
      if (trigger.closest('cart-drawer, cart-items, cart-drawer-items, .cart')) {
        scheduleCleanup();
      }
    }, true);
  }

  function boot() {
    boostLcpImage();
    wireCartFailsafe();
    if ('requestIdleCallback' in window) {
      requestIdleCallback(wireInstantNav, { timeout: 1200 });
    } else {
      window.setTimeout(wireInstantNav, 300);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();